import styled from 'styled-components';
import { mockUpBlue } from '@styles/styled/variables';

interface DataTypeProps {
  readonly?: boolean;
}

export const DataType = styled.span < DataTypeProps > `
  color: ${mockUpBlue};
  cursor: ${({ readonly }) => (readonly ? 'default' : 'pointer')};
  padding-right: 8px;
  font-weight: 600;
  font-size: 20px;
`;

export const Wrapper = styled.div`
  display: inline-flex;
`;

export const Interval = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 22px;
  height: 30px;
`;
export const DisabledUnitToggle = styled.div`
  color: #f6f6f6;
  opacity: 0.7;
  cursor: not-allowed;
  margin-right: 10px;
  :active {
    pointer-events: none;
  }
`;

export const UnitToggleWrapper = styled.div`
  margin-right: 10px;
`;

export const StyledInfo = styled.span`
  color: #096dd9;
  font-weight: 700;
  cursor: pointer;
  margin: 0 5px;
`;
